import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { Cin7ListResponse, Cin7PurchaseSummary } from "@/api/dtos";
import type { PurchaseSummary } from "./_models/Purchase";
import { toPurchaseSummaryFromCin7PurchaseSummary } from "./_transformers/toPurchaseSummaryFromCin7PurchaseSummary";

type PurchaseListResponse = Cin7ListResponse<"PurchaseList", Cin7PurchaseSummary>;

const PAGE_LIMIT = 500;

/** Cin7 purchases, first page (via the backend Cin7 proxy). */
export const getPurchaseListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPurchaseList: builder.query<PurchaseSummary[], void>({
      queryFn: async () => {
        try {
          const res = await axios.get<PurchaseListResponse>(
            `${backendBase()}/cin7/purchase-list`,
            {
              params: { Page: 1, Limit: PAGE_LIMIT },
              headers: { Accept: "application/json" },
            },
          );
          const purchases = res.data.PurchaseList.map((x) => toPurchaseSummaryFromCin7PurchaseSummary(x));
          return { data: purchases };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
    }),
  }),
});

export const getPurchaseList = getPurchaseListApi.endpoints.getPurchaseList;
